import { useCallback, useState } from "react"
import { DropResult } from "@hello-pangea/dnd"

import { DocumentCategoryWithDocuments } from "models/DocumentCategoryWithDocuments"
import { Document } from "models/Document"
import { Guid } from "@/types"
import toastMessages from "stores/toastMessages"

interface IUseReservationDocumentsParams {
    documentsByCategory: DocumentCategoryWithDocuments[]
    onDropToSelectNewCategory: (data: { sourceCategoryId: Guid, document: Document }) => void
    onDocumentCategoryChange: (data: { document: Document, sourceCategoryId: Guid, destCategoryId: Guid }) => Promise<void>
}

export default function useReservationDocuments({
    documentsByCategory,
    onDropToSelectNewCategory,
    onDocumentCategoryChange,
}: IUseReservationDocumentsParams) {
    const [isDragging, setIsDragging] = useState(false)

    const onDragStart = useCallback(() => {
        setIsDragging(true)
    }, [])

    const onDragEnd = useCallback(async (result: DropResult) => {
        setIsDragging(false)

        let doc: Document | null = null
        let sourceCategoryId = result.source.droppableId
        let destCategory: DocumentCategoryWithDocuments | null = null

        for (const category of documentsByCategory) {
            for (const document of category.documents) {
                if (document.id === result.draggableId) {
                    doc = document
                    break
                }
            }
            if (result.destination && category.id === result.destination?.droppableId) {
                destCategory = category
            }
            if (doc && destCategory) {
                break
            }
        }

        if (doc && result.destination?.droppableId === "changeCategory") {
            onDropToSelectNewCategory({ sourceCategoryId, document: doc })
            return
        }

        if (doc && destCategory && destCategory.id !== sourceCategoryId) {
            try {
                await onDocumentCategoryChange({
                    document: doc,
                    sourceCategoryId,
                    destCategoryId: destCategory.id
                })
            } catch(e) {
                toastMessages.showSystemError()
            }
        }

    }, [documentsByCategory, onDocumentCategoryChange, onDropToSelectNewCategory])

    return {
        onDragStart,
        onDragEnd,
        isDragging,
    }

}
